<template>
  <div>
    <main-header></main-header>
    <div id="custom-header" ref="us">
      <img src="../assets/images/banner/img_banner5.jpg" />
      <div class="custom-header-content">
        <div class="container">
          <h1 class="page-title">Contact Us</h1>
        </div>
      </div>
    </div>
    <div id="content" class="site-content global-layout-no-sidebar">
      <div class="container">
        <div class="inner-wrapper">
          <div id="primary" class="content-area">
            <div id="main" class="site-main">
              <!-- GET IN TOUCH -->
              <div class="section">
                <div class="container">
                  <div class="inner-wrapper">
                    <div class="col-grid-6">
                      <div class="section-title-wrap text-alignleft">
                        <h2 class="section-title">Get In Touch</h2>
                        <span class="divider"></span>
                      </div>
                      <div class="quick-contact-widget textColor">
                        <div class="quick-contact-item">
                          <svg
                            width="54px"
                            height="54px"
                            viewBox="0 0 54 54"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                          >
                            <g
                              id="Home"
                              stroke="none"
                              stroke-width="1"
                              fill="none"
                              fill-rule="evenodd"
                            >
                              <g
                                id="Page1-Home"
                                transform="translate(-371.000000, -6003.000000)"
                              >
                                <g
                                  id="Part-8"
                                  transform="translate(0.000000, 5675.000000)"
                                >
                                  <g
                                    id="get-in-touch"
                                    transform="translate(370.000000, 128.000000)"
                                  >
                                    <g
                                      id="icon_Phone"
                                      transform="translate(2.000000, 201.000000)"
                                    >
                                      <path
                                        d="M18.3277738,14 C16.7634041,14.5974002 15.540517,15.8494104 15,17.4334882 C15,20.2601702 16.8406379,25.9688987 21.031073,30.1709405 C25.4585646,34.6100374 31.2498441,36.3947368 34.5489379,36.3947368 C36.2459972,36.1860784 37.6301945,34.9340682 38,33.2645625 C36.3408435,31.7089408 34.454151,30.4189494 32.4064459,29.4420944 C32.0082579,29.5179378 31.6288725,29.669684 31.2783456,29.8879865 C30.5576562,30.333581 29.7423585,30.5897457 28.8984998,30.6371924 C26.7654686,30.6371924 20.7547453,24.6233642 20.7547453,22.4893925 C20.7831873,21.6165394 21.0676668,20.7629745 21.5794444,20.0516903 C21.7406355,19.8239818 21.8638644,19.5773421 21.9397891,19.3021868 C21.0676668,17.3481198 19.8351999,15.5460966 18.3277738,14"
                                        id="Fill-3"
                                        fill="#000000"
                                      ></path>
                                      <circle
                                        id="椭圆形"
                                        stroke="#000000"
                                        stroke-width="2"
                                        cx="26"
                                        cy="26"
                                        r="26"
                                      ></circle>
                                    </g>
                                  </g>
                                </g>
                              </g>
                            </g>
                          </svg>
                          <div class="text_left">+65 6518 9877</div>
                        </div>
                        <div class="quick-contact-item">
                          <svg
                            width="54px"
                            height="54px"
                            viewBox="0 0 54 54"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                          >
                            <g
                              id="Home"
                              stroke="none"
                              stroke-width="1"
                              fill="none"
                              fill-rule="evenodd"
                            >
                              <g
                                id="Page1-Home"
                                transform="translate(-371.000000, -6095.000000)"
                              >
                                <g
                                  id="Part-8"
                                  transform="translate(0.000000, 5675.000000)"
                                >
                                  <g
                                    id="get-in-touch"
                                    transform="translate(370.000000, 128.000000)"
                                  >
                                    <g
                                      id="icon_Email"
                                      transform="translate(2.000000, 293.000000)"
                                    >
                                      <path
                                        d="M35.9813255,20.3179267 L25.8686316,25.6689997 L16.0078944,20.4493016 C16.1035225,19.0824369 17.3427071,18 18.8578963,18 L33.1421037,18 C34.6094623,18 35.819524,19.0118697 35.9813255,20.3179267 Z M36,22.234675 L36,30.3804066 C36,31.8276894 34.7208791,33 33.1421037,33 L18.8578963,33 C17.2789882,33 16,31.8276894 16,30.3804066 L16,22.373286 L25.4175909,27.3571416 C25.7412602,27.5273118 26.1313684,27.4957222 26.4126801,27.3059415 C26.4258816,27.3011985 26.4365291,27.2938408 26.4497306,27.2865743 L36,22.234675 Z"
                                        id="Fill-1"
                                        fill="#000000"
                                      ></path>
                                      <circle
                                        id="椭圆形备份-2"
                                        stroke="#000000"
                                        stroke-width="2"
                                        cx="26"
                                        cy="26"
                                        r="26"
                                      ></circle>
                                    </g>
                                  </g>
                                </g>
                              </g>
                            </g>
                          </svg>
                          <div class="text_left">
                            info@pearlriverdecoration.com
                          </div>
                        </div>
                        <div class="quick-contact-item">
                          <svg
                            width="54px"
                            height="54px"
                            viewBox="0 0 54 54"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                          >
                            <g
                              id="Home"
                              stroke="none"
                              stroke-width="1"
                              fill="none"
                              fill-rule="evenodd"
                            >
                              <g
                                id="Page1-Home"
                                transform="translate(-371.000000, -6187.000000)"
                              >
                                <g
                                  id="Part-8"
                                  transform="translate(0.000000, 5675.000000)"
                                >
                                  <g
                                    id="get-in-touch"
                                    transform="translate(370.000000, 128.000000)"
                                  >
                                    <g
                                      id="icon_Adress"
                                      transform="translate(2.000000, 385.000000)"
                                    >
                                      <path
                                        d="M26.0093684,25.1505958 L25.9944127,25.1505958 C24.160662,25.1505958 22.6711975,23.6612533 22.6711975,21.8275027 C22.6711975,19.9939351 24.160662,18.5044633 25.9944127,18.5044633 L26.00186,18.5044633 C27.8354886,18.5006858 29.3249532,19.9864268 29.3286769,21.823779 C29.3286769,23.6575297 27.842997,25.1468111 26.0093684,25.1505958 M26.0000287,14 C23.6094991,14 21.3216449,14.950022 19.6357419,16.6402591 C17.949961,18.3306183 17,20.6229287 17,23.0090021 C17,26.5991001 21.6783839,33.7482249 24.2873886,36.8300737 C24.7110314,37.3339889 25.3355078,37.6239461 25.9955725,37.6239461 L26.0044849,37.6239461 C26.6645497,37.6239461 27.2889039,37.3339889 27.7125467,36.8300737 C30.3215515,33.7482249 35,26.594644 35,23.0090021 C35.0043916,18.0362049 30.9727039,14 26.0000287,14"
                                        id="Fill-3"
                                        fill="#000000"
                                      ></path>
                                      <circle
                                        id="椭圆形备份"
                                        stroke="#000000"
                                        stroke-width="2"
                                        cx="26"
                                        cy="26"
                                        r="26"
                                      ></circle>
                                    </g>
                                  </g>
                                </g>
                              </g>
                            </g>
                          </svg>
                          <div class="text_left">
                            2 Sims Close, #07-09, Singapore 387298
                          </div>
                        </div>
                        <div class="quick-contact-item">
                          <svg
                            width="54px"
                            height="54px"
                            viewBox="0 0 54 54"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                          >
                            <g
                              id="Contact-Us"
                              stroke="none"
                              stroke-width="1"
                              fill="none"
                              fill-rule="evenodd"
                            >
                              <g
                                id="Page5-Contact-Us"
                                transform="translate(-371.000000, -954.000000)"
                              >
                                <g
                                  id="Get-In-Touch"
                                  transform="translate(370.000000, 573.000000)"
                                >
                                  <g
                                    id="icon_worktimeiconl_black"
                                    transform="translate(2.000000, 382.000000)"
                                  >
                                    <circle
                                      id="椭圆形备份"
                                      stroke="#000000"
                                      stroke-width="2"
                                      cx="26"
                                      cy="26"
                                      r="26"
                                    ></circle>
                                    <path
                                      d="M29.7545492,16 C30.6051203,16 31.4208437,16.3446176 32.0222602,16.9580601 C32.6236767,17.5715025 32.9615385,18.4035371 32.9615385,19.2711161 L32.961,20.038 L33.4999786,20.0384615 C35.4330967,20.0384615 37,21.6205933 37,23.5721136 L37,34.8797484 C37,36.0506864 36.0598922,37 34.900141,37 L18.1000299,37 C16.9402787,37 16,36.0506864 16,34.8797484 L16,23.5721136 C16,21.6205933 17.5670743,20.0384615 19.5000214,20.0384615 L20.846,20.038 L20.8461538,19.2711161 C20.8461538,18.4035371 21.1840156,17.5715025 21.7854321,16.9580601 C22.3868487,16.3446176 23.202572,16 24.0531431,16 L29.7545492,16 Z M33.3012168,32.1 L19.698958,32.1 C18.9830151,32.1 18.625,32.4769384 18.625,33.2306772 C18.625,33.9343385 18.936871,34.3096045 19.5605418,34.3565126 L19.698958,34.3615385 L33.3012168,34.3615385 C34.0170286,34.3615385 34.375,33.9846 34.375,33.2306772 C34.375,32.4769384 34.0170286,32.1 33.3012168,32.1 Z M29.7545492,18.180818 L24.0531431,18.180818 C23.4627769,18.180818 22.9842192,18.668945 22.9842192,19.2711161 L22.984,20.038 L30.823,20.038 L30.8234731,19.2711161 C30.8234731,18.9819675 30.7109685,18.7046226 30.5104529,18.5000974 C30.3099372,18.2955722 30.0380294,18.180818 29.7545492,18.180818 Z"
                                      id="形状结合"
                                      fill="#000000"
                                    ></path>
                                  </g>
                                </g>
                              </g>
                            </g>
                          </svg>
                          <div class="work_hour">
                            <div>Working Hour</div>
                            <div class="work_time">
                              <div class="time">
                                <div>Monday - Friday</div>
                                <div>8:30-18:00</div>
                              </div>
                              <div class="line"></div>
                              <div class="time">
                                <div>Saturday</div>
                                <div>8:30-12:00</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-grid-6">
                      <div
                        id="map"
                        class="contact-form-area contactdesc map"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 求帮助 -->
              <div class="section section-skill-bar" style="padding-top: 0">
                <div class="container">
                  <div class="inner-wrapper">
                    <div class="tip">
                      <div
                        class="tipMessaage success"
                        v-if="tipMessage_success"
                      >
                        <span>
                          <svg
                            class="icon"
                            width="64px"
                            height="64px"
                            viewBox="0 0 64 64"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                          >
                            <g
                              id="邮箱界面"
                              stroke="none"
                              stroke-width="1"
                              fill="none"
                              fill-rule="evenodd"
                            >
                              <g
                                id="提交弹窗"
                                transform="translate(-272.000000, -158.000000)"
                                fill="#38D993"
                              >
                                <g
                                  id="overlay"
                                  transform="translate(46.000000, 119.000000)"
                                >
                                  <path
                                    d="M258.000157,39 C240.40011,39 226,53.4001096 226,70.9998434 C226,88.5999687 240.40011,103 258.000157,103 C275.600204,103 290,88.5999687 290,70.9998434 C290,53.2667854 275.733606,39 258.000157,39 Z M258.000157,99.0000391 C242.533453,99.0000391 230.000039,86.4666249 230.000039,70.9998434 C230.000039,55.5334534 242.533453,43.0000391 258.000157,43.0000391 C273.46686,43.0000391 285.999961,55.5334534 285.999961,70.9998434 C285.999961,86.4666249 273.46686,99.0000391 258.000157,99.0000391 Z M277.59991,57.0000979 C276.666954,56.2000744 275.333555,56.3333986 274.666621,57.1334221 L254.800141,79.1332459 L243.466723,69.8001605 C242.533453,69.1334612 241.333379,69.2668637 240.533434,70.0668089 C239.866735,70.9998434 239.866735,72.2001527 240.800082,73.0001761 L253.733469,83.6665819 C254.133442,83.9335434 254.533493,84.0666327 254.933465,84.0666327 L255.333516,84.0666327 C255.866813,84.0666327 256.266785,83.7999061 256.666836,83.3999335 L277.733312,60.0667893 C278.533258,59.1334416 278.399933,57.8001213 277.59991,57.0000979 Z"
                                    id="chenggong"
                                  ></path>
                                </g>
                              </g>
                            </g>
                          </svg>
                        </span>
                        Success!
                      </div>
                      <div class="tipMessaage error" v-if="tipMessage_error">
                        <span>
                          <svg
                            class="icon"
                            width="64px"
                            height="64px"
                            viewBox="0 0 64 64"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                          >
                            <g
                              id="邮箱界面"
                              stroke="none"
                              stroke-width="1"
                              fill="none"
                              fill-rule="evenodd"
                            >
                              <g
                                id="提交弹窗备份"
                                transform="translate(-131.000000, -155.000000)"
                                fill="#FF5A5A"
                              >
                                <g
                                  id="overlay"
                                  transform="translate(45.000000, 117.000000)"
                                >
                                  <path
                                    d="M130.82607,57.1388515 C130.403726,56.7173666 129.8306,56.4808819 129.233725,56.4820495 C128.636771,56.4833038 128.064895,56.7216635 127.643723,57.1449452 L118.000195,66.8116758 L108.356277,57.1449452 C107.480104,56.2641629 106.055884,56.261116 105.175414,57.1376015 C104.295022,58.0137744 104.291663,59.4379949 105.168148,60.3184647 L114.829098,70.0001953 L105.170883,79.6815353 C104.294397,80.5620051 104.297757,81.9862256 105.178148,82.8623985 C106.058618,83.738884 107.482839,83.7358371 108.359324,82.8553673 L118.000195,73.1883242 L127.643723,82.8612266 C128.063645,83.2866178 128.636146,83.5264618 129.233725,83.5274042 C129.831538,83.5286493 130.404664,83.2909147 130.82607,82.8670079 C131.70779,81.9941943 131.70779,80.5687238 130.83193,79.6873946 L121.17098,70.0001953 L130.823336,60.3184647 C131.245446,59.8972924 131.482868,59.3254167 131.482868,58.7287753 C131.482868,58.132134 131.245446,57.5602583 130.823336,57.1388515 L130.82607,57.1388515 Z M118.000195,38 C100.324392,38 86,52.3243925 86,70.0001953 C86,87.6756856 100.324392,102 118.000195,102 C135.675686,102 150,87.6756856 150,70.0001953 C150,52.3243925 135.675686,38 118.000195,38 Z M137.444438,89.4444378 C134.939278,91.9575659 131.969275,93.9592089 128.699661,95.3383512 C125.315517,96.7732749 121.675981,97.5087445 118.000195,97.4999949 C114.324956,97.5074945 110.685733,96.7744467 107.300417,95.3441325 C104.032835,93.9613964 101.063456,91.9599877 98.5555622,89.4502191 C96.0424341,86.9450597 94.0407911,83.9750561 92.6619613,80.7054428 C91.2273501,77.3191886 90.492193,73.6778561 90.5003282,70.0001953 C90.5003282,66.2880033 91.2276626,62.6865926 92.6558675,59.3004166 C94.0386817,56.0328345 96.0400123,53.0634559 98.5497809,50.5555622 C101.05494,48.0424341 104.024944,46.0407911 107.294557,44.6619613 C110.680811,43.2273501 114.322456,42.492193 118.000195,42.5003282 C121.711997,42.5003282 125.313407,43.2276626 128.699661,44.6558675 C131.967165,46.0386817 134.936544,48.0400123 137.444438,50.5497809 C139.957566,53.0549403 141.959209,56.0249439 143.338351,59.2945572 C144.77265,62.6808114 145.50812,66.3224564 145.499984,70.0001953 C145.516088,77.2972355 142.614757,84.2979471 137.441703,89.4444378 L137.444438,89.4444378 Z"
                                    id="shibai"
                                  ></path>
                                </g>
                              </g>
                            </g>
                          </svg>
                        </span>
                        Network error, please reload the page and try again.
                      </div>
                    </div>
                    <div class="col-grid-7">
                      <div class="video-widget">
                        <img
                          alt="About Us"
                          src="../assets/images/contactUs/img_help.png"
                        />
                      </div>
                    </div>
                    <div class="col-grid-5">
                      <div class="inner_wrapper_item">
                        <div class="contact-title">How Can We Help You?</div>
                      </div>
                      <div class="contact-form-area contactdesc">
                        <div id="contact-form" class="contact-form">
                          <div id="message"></div>
                          <div id="contactform">
                            <div class="control_all">
                              <input
                                type="text"
                                v-model="name"
                                :class="{ formControl: nameTipShow }"
                                placeholder="Name *"
                              />
                              <span v-show="nameTipShow">mandatory field.</span>
                            </div>
                            <div class="control_all">
                              <input
                                type="text"
                                v-model="email"
                                :class="{ formControl: emailTipShow }"
                                placeholder="Email *"
                              />
                              <span v-show="emailTipShow"
                                >mandatory field.</span
                              >
                            </div>
                            <div class="control_all">
                              <input
                                type="text"
                                v-model="contactNumber"
                                class="form-control"
                                placeholder="Cantact Number"
                              />
                            </div>
                            <div class="control_all">
                              <textarea
                                :class="{ formControl: desc_contentTipShow }"
                                name="comments"
                                v-model="desc_content"
                                id="comments"
                                rows="3"
                                placeholder
                              ></textarea>
                              <span v-show="desc_contentTipShow"
                                >mandatory field.</span
                              >
                            </div>
                            <div
                              class="custom-button button-curved"
                              @click="submit_contactus"
                            >
                              Submit
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <main-foot></main-foot>
    <PageScroller></PageScroller>
  </div>
</template>

<script>
import MainHeader from "../components/MainHeader";
import MainFoot from "../components//MainFoot";
import bingMap from "../utls/bingMap";
import PageScroller from "../components/PageScroller";

export default {
  name: "ContactUs",
  created() {
    let self = this;
    bingMap.init().then((Microsoft) => {
      // 开始地图操作
      self.GetMap();
    });
  },
  data() {
    return {
      tipMessage_error: false,
      tipMessage_success: false,
      name: "",
      email: "",
      contactNumber: "",
      desc_content: "",
      nameTipShow: "",
      contactNumberTipShow: false,
      emailTipShow: false,
      desc_contentTipShow: false,
      infobox: {},
    };
  },
  methods: {
    submit_contactus() {
      let self = this;
      if (self.name.length == 0) {
        self.nameTipShow = true;
        return;
      } else {
        self.nameTipShow = false;
      }
      if (self.email.length == 0) {
        self.emailTipShow = true;
        return;
      } else {
        self.emailTipShow = false;
      }
      if (self.desc_content.length == 0) {
        self.desc_contentTipShow = true;
        return;
      } else {
        self.desc_contentTipShow = false;
      }
      this.$http
        .get("http://sendmail.justtruth.cn/email_send_template", {
          params: {
            name: self.name,
            email: self.email,
            contactNumber: self.contactNumber,
            desc_content: self.desc_content,
            subject: "【 PEARL RIVER  】 A letter from " + self.name,
            recipient: "info@pearlriverdecoration.com",
            //recipient: "yangliying@justtruth.cn",
            //recipient: "1131043510@qq.com",
            template: "sgEmail",
          },
        })
        .then((res) => {
          self.tipMessage_success = true;
          setTimeout(function () {
            self.tipMessage_success = false;
          }, 3000);
          (self.name = ""),
            (self.email = ""),
            (self.contactNumber = ""),
            (self.desc_content = "");
        })
        .catch((err) => {
          self.tipMessage_error = true;
          setTimeout(function () {
            self.tipMessage_error = false;
          }, 3000);
          (self.name = ""),
            (self.email = ""),
            (self.contactNumber = ""),
            (self.desc_content = "");
          console.log(err);
        });
    },
    GetMap() {
      let _this = this;
      let map = new Microsoft.Maps.Map("#map", {
        credentials:
          "AgzeobkGvmpdZTFuGa7_6gkaHH7CXHKsFiTQlBvi55x-QLZLh1rSjhd1Da9bfPhD",
        center: new Microsoft.Maps.Location(1.328830, 103.873306),
        zoom: 16,
      });
      var center = map.getCenter();
      var randomLocation = Microsoft.Maps.TestDataGenerator.getLocations(
        1,
        map.getBounds()
      );
      //  创建一个图钉
      var pin = new Microsoft.Maps.Pushpin(center, {
        title: "Pearl River", // 图钉的标题
        text: "1", // 图钉内的文字
        color: "#0095dd",
      });
      _this.infobox = new Microsoft.Maps.Infobox(center, {
        title: "Pearl River",
        description: "2 Sims Close, #07-09, Singapore 387298",
        visible: true,
      });
      pin.metadata = {
        title: "Pearl River",
        description: "2 Sims Close, #07-09, Singapore 387298",
      };
      //map.entities.push(pin);
      _this.infobox.setMap(map);
      // Microsoft.Maps.Events.addHandler(pin, "click", _this.pushpinClicked);
      // Microsoft.Maps.Events.addHandler(map, "click", _this.getClickLocation);
    },
    //点击添加 弹框
    pushpinClicked(e) {
      //Make sure the infobox has metadata to display.
      if (e.target.metadata) {
        this.infobox.setOptions({
          location: e.target.getLocation(),
          title: e.target.metadata.title,
          description: e.target.metadata.description,
          visible: true,
        });
      }
    },
    getClickLocation(e) {
      //若点击到地图的标记上，而非地图上
      let [_this, loc] = [this, null];
      if (e.targetType == "pushpin") {
        loc = e.target.getLocation();
      }
      //若点击到地图上
      else {
        var point = new Microsoft.Maps.Point(e.pageX, e.pageY);
        loc = e.target.tryPixelToLocation(
          point,
          Microsoft.Maps.PixelReference.page
        );
      }
      console.log(loc.latitude + ", " + loc.longitude);
      console.log(loc);
      _this.lngNum = loc.longitude;
      _this.latNum = loc.latitude;
    },
  },
  components: { MainHeader, MainFoot, PageScroller },
};
</script>

<style lang="less"  scoped>
.sumitbtn {
  background: #0095dd;
  color: #fff;
  font-size: 16px;
  line-height: 1.5;
  padding: 10px 35px;
  border: none;
  height: auto;
  outline: none;
  width: auto;
  cursor: pointer;
  display: inline-block;
  &:hover {
    background-color: #222;
    color: #fff;
    outline: none;
  }
}
.formControl {
  border: 1px solid #e70000;
}
.quick-contact-widget > div:last-child {
  margin-bottom: 0px;
  align-items: end;
}
.quick-contact-item {
  .text_left {
    color: #000000;
  }
}

.inner_wrapper_item {
  display: flex;
  flex-direction: column;
  .contact-title {
    font-size: 20px;
    color: #000000;
    padding-left: 40px;
  }
}
.line {
  border-left: 1px solid #999999;
  margin: 24px 30px 0 30px;
}
.map {
  height: 420px;
  //width: 564px;
  margin-top: 60px;
  cursor: pointer;
}
.tip {
  display: flex;
  align-items: center;
  justify-content: center;
  .tipMessaage {
    width: 660px;
    height: 100px;
    border-radius: 10px;
    font-size: 18px;
    display: flex;
    align-items: center;
    text-align: left;
    padding-left: 38px;
    span {
      margin-right: 30px;
    }
  }

  .success {
    color: #38d993;
    background-color: #f5fff5;
    box-shadow: 0px 6px 15px 0px rgba(59, 74, 116, 0.22);
    border: solid 1px #38d993;
  }
  .error {
    color: #ff5a5a;
    background-color: #fff3f3;
    box-shadow: 0px 9px 15px 0px rgba(59, 74, 116, 0.21);
    border: solid 1px #ff5a5a;
    div {
      width: 417px;
      text-align: left;
    }
  }
  .icon {
    width: 32px;
    height: 32x;
  }
}
</style>
